/**
 * Custom (private) networks work only with a backend that can reach them: a
 * local run against Solo or a self-hosted deployment. The hosted app's backend
 * can't, so they are off unless the build sets
 * REACT_APP_CUSTOM_NETWORKS_ENABLED=true. The backend has its own switch,
 * CUSTOM_NETWORKS_ENABLED.
 */
export const customNetworksEnabled = (): boolean =>
  process.env.REACT_APP_CUSTOM_NETWORKS_ENABLED === 'true';
